import React from "react";
import { Row } from "react-bootstrap";

function ContactUsScreen() {
  return (
    <Row className="align-items-center">
      For any queries, please contact us on :<br></br>
      <label style={{ color: "#0a5a6a" }}>
        WhatsApp or Call - 7806873973 , 9092913756{"  "}
      </label>
      <br></br>
      <br></br>
      <label style={{ color: "#0a5a6a" }}>Email : Contactus@zpotter.in</label>
      <br></br>
    </Row>
  );
}

export default ContactUsScreen;
